<template>
    <div class="container_page">
        <a-form layout="inline">
            <a-form-item label="手机号码">
                <a-input placeholder="请输入手机号码" v-model="filterData.phone"/>
            </a-form-item>
            <a-form-item label="用户名称">
                <a-input placeholder="请输入用户名称" v-model="filterData.nickname"/>
            </a-form-item>
            <a-form-item label="账户状态">
                <a-select style="width: 200px" v-model="filterData.userSearchStatus" class="mr12" placeholder="请选择账户状态"
                          show-search option-filter-prop="name" :filter-option="filterOption">
                    <a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
                        {{ item.label }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="是否注册">
                <a-select style="width: 200px" v-model="filterData.registerStatus" class="mr12" placeholder="请选择是否注册"
                          show-search option-filter-prop="name" :filter-option="filterOption">
                    <a-select-option v-for="(item, index) of registerStatusList" :key="index" :value="item.value">
                        {{ item.label }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button icon="search" class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
                <a-button  class="mr12"  @click="toSearch(false)">重置</a-button>
                <a-button icon="export" @click="toExport">导出</a-button>
            </a-form-item>
        </a-form>

        <!-- 分类标签栏 -->
        <div class="cate">
            <a-radio-group v-model="status" @change="handleCategoryChange" style="display: flex;" button-style="solid">
                <a-radio-button style="width: 180px; text-align: center;" :value=false>全部</a-radio-button>
                <a-radio-button style="width: 180px; text-align: center;" :value=true>黑名单</a-radio-button>
            </a-radio-group>
        </div>


        <a-table :columns="columns" :sorter="false" :data-source="tableData"
                 :pagination="pageInfo" @change="changePage" :loading="loading" :rowKey="record => record.userId"
                 :customRow="customRow">

            <template slot="openIDRender" slot-scope="text, record">
                <div style="color: #f00;">
                    {{ record.openid }}
                </div>
            </template>

            <template slot="avatarImgRender" slot-scope="text, record">
                <viewer :images="[record.avatar]">
                    <div class="er_content">
                        <img class="er_avatar_img" :src="img" v-for="(img,index) in [record.avatar]" :key="index">
                    </div>
                </viewer>
            </template>

            <template slot="sexRender" slot-scope="text, record">
                <div>
                    <!-- 性别1时是男性，值为2时是女性，值为0时是未知 -->
                    {{ record.sex==1?"男":record.sex==2?"女":"未知" }}
                </div>
            </template>

            <template slot="provinceRender" slot-scope="text, record">
                <div>
                    {{ record.province }}-{{ record.city }}
                </div>
            </template>
            <template slot="deviceTypeRender" slot-scope="text, record">
                <div v-if="record.deviceType=='IOS'">
                    苹果
                </div>
                <div v-if="record.deviceType=='ANDROID'">
                    安卓
                </div>
            </template>

            <template slot="registerStatusRender" slot-scope="text, record">
                <div>
                    {{ record.registerStatus == true ? "是" : "否" }}
                </div>
            </template>

            <!-- 账户状态  账户状态 NORMAL 正常、FREEZE 冻结、BLACK 黑名单 -->
            <template slot="userStatusRender" slot-scope="text, record">
                <div class="user-status-cell">
                    <a-switch :checked="record.userStatus" @change="(checked) => handlePublishChange(checked, record)"/>
                    <!-- "freezeType": "", // 冻结状态 DAY 天  HOUR 小时  FOREVER 永久 -->
                    <!-- record.freezeType=='DAY'?'天':"" -->
                    <a-tag color="#2CBD9C" v-if="record.userStatus == true && !record.blackStatus">
                        正常
                    </a-tag>
                    <a-tag color="#ff4d4f" v-else-if="record.userStatus == false && record.freezeType  != null">
                        {{record.freezeValue}}{{ record.freezeType === 'DAY' ? '天' :
                        record.freezeType === 'HOUR' ? '小时' :
                        record.freezeType === 'FOREVER' ? '永久' : '' }}
                    </a-tag>
                    <a-tag style="background: #000; color: #fff; border-color: #000;" v-if="record.blackStatus">
                        黑名单
                    </a-tag>
                </div>
            </template>

            <template slot="action" slot-scope="text, record">
                <div class="flex_center">
                    <!-- "blackStatus": false, //是否加入黑名单 -->
                    <!-- v-if="hasPermission('PER_VIPEDIT')" -->
                    <a-button type="link" @click="toDetail(record)">查看</a-button>

                    <a-popconfirm :title="`确认将${record.nickname}用户加入黑名单，该用户将不可进行评价及留言操作？`" okText="确定" cancelText="取消"
                                  @confirm="handleAddBlack(record)">
                        <a-button v-if="record.blackStatus==false" type="link">加入黑名单</a-button>
                    </a-popconfirm>
                    <a-popconfirm :title="`确认将${record.nickname}用户解除黑名单，该用户将恢复前端评价及留言操作？`" okText="确定"
                                  cancelText="取消" @confirm="handleAddBlack(record)">
                        <a-button v-if="record.blackStatus==true" type="link">取消黑名单</a-button>
                    </a-popconfirm>


                </div>
            </template>
        </a-table>
        <a-modal :title="detailModel.title" :visible="detailModel.flag" width="1200px" @ok="detailModel.flag = false"
                 @cancel="detailModel.flag = false">
            <a-form-model :model="detailModel" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="用户">
							<span>
								{{ detailModel.userId}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="avatar">
							<span>
								{{ detailModel.avatar}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="昵称">
							<span>
								{{ detailModel.nickname}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="邀请码">
							<span>
								{{ detailModel.inviteCode}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="whatsApp">
							<span>
								{{ detailModel.whatsApp}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="上级推荐人">
							<span>
								{{ detailModel.inviteUserEmail}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="上级推荐人Id">
							<span>
								{{ detailModel.inviteUserId}}
							</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="用户状态">
							<span>
								{{ detailModel.userStatus==true?"是":detailModel.userStatus==false?'否':''}}
							</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>

        <!-- 冻结期限 -->
        <a-modal :title="freePopModal.title" :visible="freePopModal.flag" width="600px" @ok="freePopModal.onOk"
                 @cancel="freePopModal.flag = false">
            <div style="padding: 20px 0;">
                <a-radio-group v-model="freePopModal.freezeType" @change="onChange">
                    <!-- 选项1：天数 -->
                    <a-row style="margin-bottom: 20px; align-items: center;">
                        <a-col :span="2" style="line-height: 32px;">
                            <a-radio :value="'DAY'"></a-radio>
                        </a-col>
                        <a-col :span="18">
                            <a-input v-model.number="freePopModal.freezeDays" placeholder="请输入天数（整数）"
                                     :disabled="freePopModal.freezeType !== 'DAY'"
                                     oninput="value=value.replace(/\D/g,'').trim()"/>
                        </a-col>
                        <a-col :span="4" style="line-height: 32px;">
                            天
                        </a-col>
                    </a-row>

                    <!-- 选项2：小时+分钟 -->
                    <a-row style="margin-bottom: 20px; align-items: center;">
                        <a-col :span="2" style="line-height: 32px;">
                            <a-radio :value="'HOUR'"></a-radio>
                        </a-col>
                        <a-col :span="18">
                            <a-input v-model.number="freePopModal.freezeHours" placeholder="24小时内"
                                     :disabled="freePopModal.freezeType !== 'HOUR'"
                                     oninput="value=value.replace(/\D/g,'').trim()"/>
                        </a-col>
                        <a-col :span="4" style="line-height: 32px;">小时</a-col>
                    </a-row>

                    <!-- 选项3：永久 -->
                    <a-row style="align-items: center;">
                        <a-col :span="2" style="line-height: 32px;">
                            <a-radio :value="'FOREVER'"></a-radio>
                        </a-col>
                        <a-col :span="22" style="line-height: 32px;">
                            永久
                        </a-col>
                    </a-row>
                </a-radio-group>
            </div>

        </a-modal>

    </div>
</template>

<script>
    import {
        getUserListApi,
        userBlackApi,
        userStatusApi,
        usersExportApi,
    } from "../../api/index";
    import {
        getFormatAmount
    } from "../../utils/util"

    export default {
        name: "VIPLIST",
        data() {
            return {
                status: false,
                value: 1,
                radioStyle: {
                    display: 'block',
                    height: '30px',
                    lineHeight: '30px',
                    marginBottom: '10px'
                },
                uploadingLoading: false,
                orderStaticsVO: {},
                filterData: {
                    timeDate: [],
                    phone: "",
                    nickname: "",
                    userSearchStatus: undefined,
                    registerStatus: undefined,
                },
                // 账户状态
                commodityStatusList: [{
                    label: "正常",
                    value: 'NORMAL',
                },
                    {
                        label: "冻结",
                        value: 'FREEZE',
                    },
                    {
                        label: "黑名单",
                        value: 'BLACK',
                    },
                ],
                // 是否注册 true 是 false 否
                registerStatusList: [{
                    label: "是",
                    value: 'true',
                },
                    {
                        label: "否",
                        value: 'false',
                    },
                ],
                columns: [{
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    customRender: (text, record, index) => {
                        return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
                    }
                },
                    {
                        title: "openid",
                        dataIndex: "openid",
                        key: "openid",
                        scopedSlots: {
                            customRender: "openIDRender"
                        },
                        width: 150,
                        className: "red-header",
                    },
                    {
                        title: "头像",
                        dataIndex: "avatar",
                        key: "avatar",
                        scopedSlots: {
                            customRender: "avatarImgRender"
                        },
                        width: 80,
                    },
                    {
                        title: "用户名称",
                        dataIndex: "nickname",
                        key: "nickname",
                    },
                    {
                        title: "手机号码",
                        dataIndex: "phone",
                        key: "phone",
                    },
                    {
                        title: "性别",
                        dataIndex: "sex",
                        key: "sex",
                        scopedSlots: {
                            customRender: "sexRender"
                        },
                    },
                    {
                        title: "归属（国）",
                        dataIndex: "country",
                        key: "country",
                    },
                    {
                        title: "所在地",
                        dataIndex: "province",
                        key: "province",
                        scopedSlots: {
                            customRender: "provinceRender"
                        },
                    },
                    {
                        title: "使用设备",
                        dataIndex: "deviceType",
                        key: "deviceType",
                        scopedSlots: {
                            customRender: "deviceTypeRender"
                        },
                    },
                    {
                        title: "是否注册",
                        dataIndex: "registerStatus",
                        key: "registerStatus",
                        scopedSlots: {
                            customRender: "registerStatusRender"
                        }
                    },
                    {
                        title: "首次登录时间",
                        dataIndex: "firstLoginTime",
                        key: "firstLoginTime",
                    },
                    {
                        title: "最近浏览时间",
                        dataIndex: "lastLoginTime",
                        key: "lastLoginTime",
                    },
                    {
                        title: "账户状态",
                        key: "userStatus",
                        scopedSlots: {
                            customRender: "userStatusRender"
                        },
                    }, {
                        title: "操作",
                        key: "action",
                        scopedSlots: {
                            customRender: "action"
                        },
                        fixed: 'right'

                    },
                ],
                tableData: [],
                pageInfo: {
                    pageSize: 10,
                    current: 1,
                    total: 0,
                    nickname: "",
                    phone: "",
                    userSearchStatus: "",
                    registerStatus: "",
                    showTotal: (total, range) => {
                        return `合计 ${total} 条记录`;
                    },
                },
                loading: false,
                // 用户状态
                options: [{
                    label: "在线",
                    value: "true",
                },
                    {
                        label: "离线",
                        value: "false",
                    }
                ],
                deviceType: [{
                    label: "iOS",
                    value: "iOS",
                },
                    {
                        label: "Android",
                        value: "ANDROID",
                    },
                    {
                        label: "H5",
                        value: "H5",
                    }
                ],
                // 排序
                orderByOptions: [{
                    label: "递增",
                    value: "ASC",
                },
                    {
                        label: "递减",
                        value: "DESC",
                    }
                ],
                // 模拟用户
                simStatusOptions: [{
                    label: "是",
                    value: "true",
                },
                    {
                        label: "否",
                        value: "false",
                    }
                ],
                deleteStatusList: [{
                    label: "删除",
                    value: 'true',
                },
                    {
                        label: "未删除",
                        value: 'false',
                    }
                ],
                operationTypeList: [{
                    label: "加",
                    value: 1,
                },
                    {
                        label: "减",
                        value: 0,
                    }
                ],
                // 用户状态
                userOptions: [{
                    label: "正常",
                    value: 'true',
                },
                    {
                        label: "封禁",
                        value: 'false',
                    }
                ],
                simulateOptions: [{
                    label: "是",
                    value: 'true',
                },
                    {
                        label: "否",
                        value: false
                    }
                ],
                columnsRecord: [{
                    title: "ID",
                    dataIndex: "userVipRecordId",
                    key: "userVipRecordId",
                },
                    // here
                    {
                        title: "升级状态",
                        scopedSlots: {
                            customRender: "status"
                        },
                        key: "status"
                    },
                    {
                        title: "标题",
                        dataIndex: "userVipRecordTitle",
                        key: "userVipRecordTitle",
                    },
                    {
                        title: "时间",
                        dataIndex: "createTime",
                        key: "createTime"
                    },
                ],

                columnsScore: [{
                    title: "标题",
                    dataIndex: "title",
                    key: "title",
                },
                    {
                        title: "时间",
                        dataIndex: "createTime1",
                        key: "createTime1"
                    },
                    {
                        title: "积分",
                        key: "userScore",
                        scopedSlots: {
                            customRender: "userScore"
                        },
                    },
                ],
                tableDataRecord: [],
                pageInfoRecord: {
                    pageSize: 10,
                    current: 1,
                    total: 0
                },
                loadingRecord: false,
                scoreList: [],
                pageScore: {
                    pageSize: 10,
                    current: 1,
                    total: 0
                },
                detailModel: {
                    flag: false,
                    title: "",
                    userId: '',
                    avatar: "",
                    nickname: "",
                    inviteCode: "",
                    whatsApp: "",
                    inviteUserEmail: "",
                    inviteUserId: '',
                    userStatus: "",
                    simulateStatus: "",
                },
                editModel: {
                    flag: false,
                    title: "",
                    avatar: '',
                    inviteCode: "",
                    whatsApp: "",
                    nickname: "",
                    inviteUserId: "",
                    userStatus: undefined,
                    userId: '',
                    password: null,
                    simulateStatus: undefined,
                    onOk: () => {
                    },
                },
                userInfo: {},
                freePopModal: {
                    flag: false,
                    title: "",
                    userId: "",
                    freezeType: 'DAY', // 默认选中：1-天 2-时分 3-永久
                    freezeValue: '',
                    freezeDays: '',
                    freezeHours: '',
                    freezeMinutes: '',
                    onOk: () => {
                    },
                },
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
                tableEmailData: [],
                tableDataVip: [],
                // 推荐人
                inviteUserStatusList: [{
                    label: "是",
                    value: 'true',
                },
                    {
                        label: "否",
                        value: 'false',
                    }
                ],
                // 交易奖励
                awardPriceStatusList: [{
                    label: "大于0",
                    value: 'true',
                },
                    {
                        label: "等于0",
                        value: 'false',
                    }
                ],
                scoreUserId: "",
            };
        },
        created() {
        },
        activated() {
            this.getData(this.pageInfo.current);
        },
        mounted() {
            const storedQuery = localStorage.getItem('vipList_searchQuery');
            if (storedQuery) {
                this.filterData = JSON.parse(storedQuery);
            }
            const storedPage = localStorage.getItem('vipList_pageNo');
            if (storedPage) {
                this.pageInfo.current = parseInt(storedPage);
            }
            this.getData(this.pageInfo.current);
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem('vipList_searchQuery', JSON.stringify(this.filterData));
            localStorage.setItem('vipList_pageNo', this.pageInfo.current);
            next();
        },
        methods: {
            handleCategoryChange(value) {
                this.status = value.target.value;
                this.getData(1);
            },
            // 切换发布状态（带确认提示）
            handlePublishChange(checked, record) {
                if (record.userStatus) {
                    if (record.freezeType == 'DAY') {
                        this.freePopModal.freezeDays = record.freezeValue
                    }
                    if (record.freezeType == 'HOUR') {
                        // todo，这里要修改
                        this.freePopModal.freezeHours = record.freezeHours
                    }


                    this.freePopModal = {
                        flag: true,
                        title: "冻结期限",
                        freezeType: "DAY",
                        onOk: () => {
                            // 确认后执行的操作
                            // record.userStatus = checked ? true : false;
                            // 这里可以调用接口更新状态
                            // 必填
                            if (!this.freePopModal.freezeType) {
                                this.$message.error("请选择冻结期限");
                                return;
                            }

							if (this.freePopModal.freezeType === 'DAY') {
								if (!this.freePopModal.freezeDays && this.freePopModal.freezeDays !== 0) {
									// 如果为空但非0，报错
									this.$message.error("请输入冻结天数");
									return;
								}
								if (this.freePopModal.freezeDays === 0) {
									this.$message.error("冻结天数不能为0");
									return;
								}
							}

							if (this.freePopModal.freezeType === 'HOUR') {
								const { freezeHours, freezeMinutes } = this.freePopModal;
								if (!freezeHours && !freezeMinutes) {
									this.$message.error("请输入冻结时间");
									return;
								}
								if (freezeHours === 0 && freezeMinutes === 0) {
									this.$message.error("冻结时间不能都为0");
									return;
								}
							}
                            let params = {
                                'userId': record.userId,
                                "freezeType": this.freePopModal.freezeType,
                                // "freezeValue": ""
                            }

                            // 赋值 freezeValue
                            if (this.freePopModal.freezeType == "DAY") {
                                // debugger //   // 天：直接传数字
                                params.freezeValue = this.freePopModal.freezeDays;

                            } else if (this.freePopModal.freezeType == "HOUR") {
                                // 小时：格式化为 HH:MM，空值补 0
                                const h = this.freePopModal.freezeHours || 0;
                                params.freezeValue = `${h}`;

                            } else if (this.freePopModal.freezeType == "FOREVER") {
                                // 永久冻结：可传空 / 固定值，按接口要求来
                                params.freezeValue = "";
                            }

                            userStatusApi(params)
                                .then((res) => {
                                    if (res.resultStatus) {
                                        this.$message.success("冻结成功");
                                    } else {
                                        console.log("res", res);
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                })
                                .finally(() => {
                                    this.freePopModal.flag = false
                                    this.loading = false;
                                    this.getData(this.pageInfo.current);
                                });

                        },
                        onCancel: () => {
                        }
                    };
                } else {
                    this.$confirm({
                        title: `确认取消对"${record.nickname}"用户的冻结？`,
                        content: '该用户将恢复前端全部操作',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: () => {
                            let params = {
                                'userId': record.userId,
                            }
                            return userStatusApi(params)
                                .then((res) => {
                                    if (res.resultStatus) {
                                        this.$message.success("解冻成功");
                                    } else {
                                        console.log("res", res);
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                })
                                .finally(() => {
                                    this.freePopModal.flag = false
                                    this.loading = false;
                                    this.getData(this.pageInfo.current);
                                });
                        },
                        onCancel: () => {}
                    });
                }

            },
            customRow(record, index) {
                // 假设你的字段名是 'isError'，根据实际情况修改
                if (record.deleteStatus === true) {
                    return {
                        style: {
                            'color': 'red'
                        }
                    };
                }
                // 如果字段不为true，返回空对象，不应用特殊样式
                return {};
            },
            hasPermission(permission) {
                return true
                // return this.$store.state.userInfo.resources.split(";").includes(permission)
            },
            // 跳转页面传递参数
            UserEmail(email) {
                if (email) {
                    // 将参数添加到邮箱查询条件中
                    this.filterData.inviteUserEmail = email;
                    this.getData(1);
                }
            },
            toEmail(email) {
                if (email) {
                    // 将参数添加到邮箱查询条件中
                    this.filterData.email = email;
                    this.getData(1);
                }
            },
            toWatsApp(whatsAppNumber) {
                window.open(`https://wa.me/+234${whatsAppNumber}`, '_blank')
            },
            toShowIp(ip) {
                if (ip) {
                    window.open(`https://www.ip138.com/iplookup.php?ip=${ip}&action=2`, '_blank')
                }

            },
            toWalletList(email) {
                this.$store.commit("ADD_LABEL", "WALLETLIST");
                this.$router.push({
                    name: 'WALLETLIST',
                    query: {
                        email: email,
                        t: Date.now(),
                        clear: true
                    }
                })
            },
            handleBlur() {
                console.log('blur');
            },
            handleFocus() {
                console.log('focus');
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            toSearch(flag) {
                if (flag) {
                    this.getData(1);
                } else {
                    this.filterData = {
                        nickname: "",
                        phone: "",
                        userSearchStatus: undefined,
                        registerStatus: undefined,
                    };
                    this.getData(1);
                }
            },
            toExport() {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                usersExportApi({
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,
                    nickname: this.filterData.nickname,
                    phone: this.filterData.phone,
                    userSearchStatus: this.filterData.userSearchStatus,
                    registerStatus: this.filterData.registerStatus,
                })
                    .then((res) => {
                        this.$convertRes2Blob(res, "用户列表");
                        this.$message.success("导出成功");
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            changePage(page, filters, sorter) {
                this.pageInfo.current = page.current;

                // 处理排序信息

                // 排序使用 ASC 递增 DESC 递减
                console.log(sorter)
                if (sorter && sorter.columnKey) {
                    this.filterData.orderByTitle = sorter.columnKey; // 排序字段（如 "orderPrice"）
                    if (sorter.order == "ascend") {
                        this.filterData.orderBy = "ASC"
                    } else if (sorter.order == "descend") {
                        this.filterData.orderBy = "DESC"
                    } else {

                    }
                } else {
                    // 若取消排序，清空参数
                    this.filterData.orderBy = "";
                    this.filterData.orderByTitle = ""
                }

                this.getData(this.pageInfo.current);
            },
            getData(page = 1) {
                this.pageInfo.current = page;
                if (this.loading) {
                    return;
                }
                this.loading = true;

                let params = {
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,
                    phone: this.filterData.phone,
                    nickname: this.filterData.nickname,
                    userSearchStatus: this.filterData.userSearchStatus,
                    registerStatus: this.filterData.registerStatus,
                }
                if (this.status == true) {
                    params.blackStatus = true
                }

                getUserListApi(params)
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableData = res.resultData.dataList || [];

                            this.pageInfo.total = res.resultData.totalNum || 0;
                            this.orderStaticsVO = res.resultData.userStatics
                        } else {
                            this.tableData = [];
                            this.pageInfo.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 上传文件
            handleUpdataFile(e) {
                if (e.target.files.length) {
                    const file = e.target.files[0];
                    console.log("file", file);
                    if (file) {
                        const form = new FormData();
                        form.append("file", file);
                        console.log("form", form);
                        getOssAuth(form).then((res) => {
                            if (res.resultStatus) {
                                this.editModel.avatar = res.resultData.fileLink;
                            }
                        });
                    }
                }
            },
            onChange() {

            },
            onChangeDate() {
                this.getData(1);
            },
            // 加入黑名单
            handleAddBlack(data) {
                userBlackApi({
                    userId: data.userId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success("加入黑名单成功");
                        } else {
                            console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.getData(this.pageInfo.current);
                    });
            },
            // 查看
            toDetail(data) {
                this.$router.push({
                    name: 'VIPDETAIL',
                    params: {
                        id: data.userId
                    }
                });
            },

            // 编辑
            toEdit(data) {
                this.userInfo = data
                this.editModel = {
                    flag: true,
                    title: "编辑",
                    avatar: data.avatar,
                    userId: data.userId,
                    inviteCode: data.inviteCode,
                    whatsApp: data.whatsApp,
                    nickname: data.nickname,
                    inviteUserId: data.inviteUserId,
                    userStatus: data.userStatus,
                    password: "",
                    onOk: this.sureEdit,
                    simulateStatus: data.simulateStatus
                };
                console.log(this.editModel, 'this.editModelthis.editModel')
            },
            userVipRecordslApi() {
                userVipRecordslApi({
                    userId: this.scoreUserId,
                    pageNo: this.pageScore.current
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableDataRecord = res.resultData.dataList || [];
                            this.pageInfoRecord.total = res.resultData.totalNum || 0;
                        } else {
                            this.tableDataRecord = [];
                            this.pageInfoRecord.total = 0;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                    })
            },

            userScoreRecordslApi() {
                userScoreRecordslApi({
                    userId: this.scoreUserId,
                    pageNo: this.pageScore.current
                })
                    .then((res) => {
                        if (res.resultStatus) {

                            this.scoreList = res.resultData.dataList || [];
                            this.pageScore.total = res.resultData.totalNum || 0;
                        } else {
                            this.scoreList = [];
                            this.pageScore.total = 0;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                    })
            },
            recordEdit() {

            },

            changeRecordPage(page) {
                this.pageInfoRecord.current = page.current;
                this.userVipRecordslApi();
            },
            changeScoreRecordPage(page) {
                this.pageScore.current = page.current;
                this.userScoreRecordslApi();
            },

            sureEdit() {

                userEditlApi({
                    userId: this.editModel.userId,
                    name: this.editModel.name,
                    avatar: this.editModel.avatar, //头像
                    nickname: this.editModel.nickname, //昵称
                    inviteCode: this.editModel.inviteCode, //邀请码
                    whatsApp: this.editModel.whatsApp, //whatsApp
                    inviteUserId: this.editModel.inviteUserId, //上级推荐人Id
                    userStatus: this.editModel.userStatus, //用户状态  true 正常 false 封禁
                    password: this.editModel.password ? this.editModel.password : null, //密码  密码为空的话，传null 代表不修改
                    simulateStatus: this.editModel.simulateStatus,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(
                                this.editModel.userId ? "修改成功" : "修改成功"
                            );
                            this.editModel.flag = false;
                        } else {
                            console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.getData(this.pageInfo.current)
                    })
            },

            // 会员升降级记录


            beforeUpload(file) {
                const isValidType = /\.(xlsx|xls|csv)$/i.test(file.name);
                const isSizeValid = file.size / 1024 / 1024 < 10;

                if (!isValidType) {
                    this.$message.error('只能上传 Excel文件!');
                    return false;
                }
                return true;
            },
            customRequest(options) {
                const {
                    file,
                    onSuccess,
                    onError
                } = options;
                this.processFile(file)
            },
            // 订单导入
            processFile(file) {
                this.uploadingLoading = true
                if (file) {
                    const formData = new FormData();
                    formData.append("file", file);
                    userImportApi(formData).then((res) => {
                        if (res.resultData.fileUrl == null) {
                            this.$message.success("导入成功");
                            this.getData(1);
                        } else {
                            let fileUrl = res.resultData.fileUrl
                            const encodedUrl = encodeURI(fileUrl);
                            const link = document.createElement('a');
                            link.href = encodedUrl;
                            link.download = '未成功导入的订单.xlsx'; // 设置下载的文件名
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    }).catch((err) => {
                        console.error(err);
                    })
                        .finally(() => {
                            this.uploadingLoading = false;
                        });
                }
            }

        },
    };
</script>

<style lang="less">
    .container_page {
        padding: 20px;
        background: #ffffff;

        .cate {
            margin: 20px 0;

            .ant-radio-button-wrapper {
                width: 100px !important;
                text-align: center !important;
            }
        }

        .mr12 {
            margin-right: 12px;
        }
    }

    .red-header {
        color: #f00 !important;
    }

    .user-status-cell {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;

        .ant-switch,
        .ant-tag {
            flex: 0 0 auto;
        }

        .ant-tag {
            margin: 0;
        }
    }
</style>
